<template>
  <div class="view box grow integration-content">
    <page-headers
        :header="'Launchpad'"
        :breadcrumbs="breadcrumbs"
        :is-border="true"
        documentation="page-integration"
        class="box"
    >
    </page-headers>
    <div class="mt-32 ml-47">
      <span class="mb-20 bold launchpad-title">
        Welcome to XM Cyber Confluera Launchpad!
      </span>
      <div class="launchpad-subtitle">
        <p style="width: 786px;">
          Follow these steps to set up XM Cyber Confluera CxDR:
          <span class="text-btn" @click="loadDocumentation('page-integration')"> Learn More </span>
        </p>
      </div>
    </div>
    <div class="pt-41 pl-47">
      <span class="cloud-assets">
        1. Add your Cloud Accounts.
      </span>
      <el-row :gutter="20" :type="'flex'" class="integration-row mt-10" style="margin-left: 0px; margin-right: 0px;">
        <div v-loading="integrationListReqStatus === 'loading'" style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-aws-color"
            title="Install"
            :routeLink="{ name: 'discoveryintegration-accounts', query: { type: 'aws' } }"
            @click.native="gotoConfigure('aws')"
            @add-click="gotoConfigure('aws')"
            v-if="integrationListReqStatus !== 'loading'"
          >
            <div slot="card_header">
              Amazon Web Services
            </div>
            <div slot="card_footer" v-if="cloudIntegrations.length > 0">
              <router-link
                class="display-inline-block "
                :to="{ name: 'discoveryintegration-accounts', query: { type: 'aws' } }"
                style="text-decoration: none;"
                @click.native.stop.prevent
              >
                <a style="text-decoration: none; color: #faa01a; font-size: 14px;"
                  >{{ cloudIntegrations.length }} Accounts</a
                >
              </router-link>
              <i
                class="display-inline-block fal fa-exclamation-triangle"
                v-if="cloudIntegrationSummary.unhealthyAwsCount > 0"
              ></i>
            </div>
          </integration-card>
        </div>
        <div v-loading="integrationListReqStatus === 'loading'" style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-only-gcp-color"
            title="Install"
            :routeLink="{ name: 'discoveryintegration-accounts', query: { type: 'gcp' } }"
            @click.native="gotoConfigure('gcp')"
            @add-click="gotoConfigure('gcp')"
            v-if="integrationListReqStatus !== 'loading'"
          >
            <div slot="card_header">
              Google Cloud
            </div>
            <div slot="card_footer" v-if="gcpIntegrations.length > 0">
              <router-link
                class="display-inline-block "
                :to="{ name: 'discoveryintegration-accounts', query: { type: 'gcp' } }"
                style="text-decoration: none;"
                @click.native.stop.prevent
              >
                <a style="text-decoration: none; color: #faa01a; font-size: 14px;"
                  >{{ gcpIntegrations.length }} Accounts</a
                >
              </router-link>
              <i
                class="display-inline-block fal fa-exclamation-triangle"
                v-if="cloudIntegrationSummary.unhealthyGCPCount > 0"
              ></i>
            </div>
          </integration-card>
        </div>
        <div v-loading="integrationListReqStatus === 'loading'" style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-only-azure-color"
            title="Install"
            :routeLink="{ name: 'discoveryintegration-accounts', query: { type: 'azure' } }"
            @click.native="gotoConfigure('azure')"
            @add-click="gotoConfigure('azure')"
            v-if="integrationListReqStatus !== 'loading'"
          >
            <div slot="card_header">
              Microsoft Azure
            </div>
            <div slot="card_footer" v-if="azureIntegrations.length > 0">
              <router-link
                class="display-inline-block "
                :to="{ name: 'discoveryintegration-accounts', query: { type: 'azure' } }"
                style="text-decoration: none;"
                @click.native.stop.prevent
              >
                <a style="text-decoration: none; color: #faa01a; font-size: 14px;"
                  >{{ azureIntegrations.length }} Accounts</a
                >
              </router-link>
              <i
                class="display-inline-block fal fa-exclamation-triangle"
                v-if="cloudIntegrationSummary.unhealthyAzureCount > 0"
              ></i>
            </div>
          </integration-card>
        </div>
      </el-row>
      <span class="cloud-assets">
        2. Deploy XM Cyber Confluera sensors.
      </span>
      <el-row :gutter="20" :type="'flex'" class="integration-row mt-10" style="margin-left: 0px; margin-right: 0px;">
        <div v-loading="integrationListReqStatus === 'loading'" style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-confluera"
            title="Install"
            @add-click="gotoConfigure('installation')"
            @click.native="gotoConfigure('installation')"
            v-if="integrationListReqStatus !== 'loading'"
          >
            <div slot="card_header">
              Confluera Agent
            </div>
            <div slot="card_footer" v-if="cloudIntegrations.length > 0" style="white-space: nowrap;">
              <!-- <router-link class="display-block " :to="{ name: 'discoveryintegration-accounts' }" style="text-decoration: none;">
                  <a style="text-decoration: none; color: #faa01a; font-size: 14px;">{{ cloudIntegrationSummary.agentInstalledCount }} Protected</a>
                </router-link> -->
              <router-link
                class="display-block "
                :to="{ name: 'discoveryintegration-accounts' }"
                style="text-decoration: none;"
                @click.native.stop.prevent
              >
                <a style="text-decoration: none; color: #faa01a; font-size: 14px;"
                  >{{ cloudIntegrationSummary.vmCount - cloudIntegrationSummary.agentInstalledCount }} Unprotected</a
                >
              </router-link>
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;" v-if="cloudIntegrationSummary.upgradeableCount > 0">
          <integration-card
            icon-class="integration-icon logo-confluera"
            title="Install"
            button-text="update"
            @add-click="gotoConfigure('installation')"
            @click.native="gotoConfigure('installation')"
          >
            <div slot="card_header">
              Confluera Update
            </div>
            <div slot="card_footer" style="white-space: nowrap;">
              <router-link
                class="display-inline-block "
                :to="{ name: 'discoveryintegration-accounts' }"
                style="text-decoration: none;"
                @click.native.stop.prevent
              >
                <a style="text-decoration: none; color: #faa01a; font-size: 14px;"
                  >{{ cloudIntegrationSummary.upgradeableCount || 0 }} Sensors ready for update</a
                >
              </router-link>
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-kubernetes-color"
            title="Install"
            button-text="Add"
            :accounts="kubernetesIntegrations"
            :routeLink="{ name: 'install-agent', query: { os: 'kubernetes' } }"
            @add-click="gotoConfigure('kubernetes')"
            @click.native="gotoConfigure('kubernetes')"
          >
            <div slot="card_header">
              Kubernetes
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-wef-color"
            title="Install"
            button-text="Add"
            :accounts="wefIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'wef' } }"
            @add-click="gotoConfigure('wef')"
            @click.native="gotoConfigure('wef')"
          >
            <div slot="card_header">
              WEF
            </div>
          </integration-card>
        </div>
      </el-row>
      <span class="cloud-assets">
        3. Add Confluera Partner signals.
      </span>
      <el-row
        :gutter="20"
        :type="'flex'"
        class="integration-row mt-10"
        style="flex-wrap: wrap; margin-left: 0px; margin-right: 0px;"
      >
        <div style="margin-right: 2.5%;">
          <integration-card
            title="SNYK"
            icon-class="integration-icon logo-snyk"
            :accounts="snykIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'snyk' } }"
            @add-click="gotoConfigure('snyk')"
            @click.native="gotoConfigure('snyk')"
          >
            <div slot="card_header">
              Snyk Developer Tools
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            title="PAN"
            icon-class="integration-icon logo-paloalto-networks-color"
            :accounts="panIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'pan' } }"
            @add-click="gotoConfigure('pan')"
            @click.native="gotoConfigure('pan')"
          >
            <div slot="card_header">
              Palo Alto networks
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            title="TrendMicro"
            icon-class="integration-icon logo-trendmicro-color"
            :accounts="trendmicroIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'trendmicro' } }"
            @add-click="gotoConfigure('trendmicro')"
            @click.native="gotoConfigure('trendmicro')"
          >
            <div slot="card_header">
              Trend Micro
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-aws-color"
            :accounts="albIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'alb' } }"
            @add-click="gotoConfigure('awslb')"
            @click.native="gotoConfigure('awslb')"
          >
            <div slot="card_header">
              Elastic Load Balancing
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-aws-color"
            :accounts="guarddutyblackIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'guardduty' } }"
            @add-click="gotoConfigure('guardduty')"
            @click.native="gotoConfigure('guardduty')"
          >
            <div slot="card_header">
              Amazon Guard Duty
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-vmware-carbonblack-color"
            :accounts="carbonblackIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'carbonblack' } }"
            @add-click="gotoConfigure('carbonblack')"
            @click.native="gotoConfigure('carbonblack')"
          >
            <div slot="card_header">
              Vmware Carbon Black
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-aws-rds-color"
            :accounts="rdsIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'rds' } }"
            @add-click="gotoConfigure('rds')"
            @click.native="gotoConfigure('rds')"
          >
            <div slot="card_header">
              Amazon RDS
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-aws-cloudtrail-color"
            :accounts="cloudtrailIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'cloudtrail' } }"
            @add-click="gotoConfigure('cloudtrail')"
            @click.native="gotoConfigure('cloudtrail')"
          >
            <div slot="card_header">
              AWS CloudTrail
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-devo-color"
            :accounts="devoIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'devo' } }"
            @add-click="gotoConfigure('devo')"
            @click.native="gotoConfigure('devo')"
          >
            <div slot="card_header">
              DEVO
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-aws-cloudtrail-history-color"
            :accounts="historicalCloudTrailDataIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'cloudtrail_history' } }"
            @add-click="gotoConfigure('cloudtrail_history')"
            @click.native="gotoConfigure('cloudtrail_history')"
          >
            <div slot="card_header">
              CLOUDTRAIL EVENT HISTORY
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-azure-log-color"
            :accounts="azurelogIntegrations"
            :routeLink="{ name: 'alertintegration-accounts', query: { type: 'azurelog' } }"
            @add-click="gotoConfigure('azurelog')"
            @click.native="gotoConfigure('azurelog')"
          >
            <div slot="card_header">
              AZURE LOGS
            </div>
          </integration-card>
        </div>
      </el-row>
      <div class="cloud-assets mt-55">
        4. Configure your users, communication, and ticket tracking.
      </div>
      <el-row :gutter="20" :type="'flex'" class="integration-row mt-30" style="margin-left: 0px; margin-right: 0px;">
        <div v-loading="usersListStatus === 'loading'" style="margin-right: 2.5%;">
          <integration-card
            icon-class="integration-icon logo-team"
            title="Install"
            @add-click="gotoUsers()"
            @click.native="gotoUsers()"
            v-if="usersListStatus !== 'loading'"
          >
            <div
              slot="card_header"
              style="height: 40px; width: 166px; color: #454B60; font-size: 13px; letter-spacing: 0; line-height: 20px;"
            >
              Add users and set permissions
            </div>
            <div slot="card_footer" v-if="usersList.models.length > 0" class="hidden">
              <router-link
                class="display-block "
                :to="{ name: 'preferences', query: { view: 'users' } }"
                style="text-decoration: none;"
                @click.native.stop.prevent
              >
                <a style="text-decoration: none; color: #1A90FA; font-size: 14px;"
                  >{{ usersList.models.length || 0 }} Users</a
                >
              </router-link>
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;" v-if="$allow('users', 'write')">
          <integration-card
            icon-class="integration-icon logo-slack-color"
            title="Install"
            button-text="Add"
            @add-click="gotoNotifications()"
            @click.native="gotoNotifications()"
          >
            <div
              slot="card_header"
              style="height: 40px; width: 166px; color: #454B60; font-size: 13px; letter-spacing: 0; line-height: 20px;"
            >
              Add slack channels
            </div>
            <div slot="card_footer" class="hidden">
              <a>Alert</a>
            </div>
          </integration-card>
        </div>
        <div style="margin-right: 2.5%;" v-if="$allow('users', 'write')">
          <integration-card
            icon-class="integration-icon logo-jira-color"
            title="Install"
            button-text="Add"
            @add-click="gotoConfigure('jira')"
            @click.native="gotoConfigure('jira')"
          >
            <div slot="card_header" class="jira-logo-header">
              Track your security projects in Jira
            </div>
            <div slot="card_footer" class="hidden">
              <a>Alert</a>
            </div>
          </integration-card>
        </div>
      </el-row>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'
import { NANOSECONDS_TO_MILLISECONDS, DATETIME_FORMAT_SHORT } from '@/constants/datetime.constants'
import { mapGetters } from 'vuex'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import IntegrationCard from '@/components/card/integration/IntegrationCard.vue'
import { USER_LIST_REQUEST, USER_LIST_SUCCESS } from '@/store/modules/user/user.type'
import { INTEGRATIONS_LIST_REQUEST } from '@/store/modules/integrations/integrations.type'
import { CLOUD_ACCOUNTS_LIST_REQUEST } from '@/store/modules/integration_accounts/integration-accounts.type'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'Integrations',
  mixins: [loadDocumentationMixin],
  data () {
    return {
      breadcrumbs: [{ title: 'Setup' }, { title: 'Launchpad' }],
      loading: false,
      dialogVisible: false,
      alertDialog: {
        content: {},
        title: ''
      }
    }
  },
  methods: {
    getFormatedDateTime (timeVal) {
      // convert startTime to ms if necessary
      if (timeVal && !moment(timeVal).isValid()) {
        timeVal = timeVal * NANOSECONDS_TO_MILLISECONDS
      }
      return moment(timeVal).format(DATETIME_FORMAT_SHORT)
    },
    callApi () {
      this.loading = true
      let apiList = [this.$store.dispatch(INTEGRATIONS_LIST_REQUEST), this.$store.dispatch(CLOUD_ACCOUNTS_LIST_REQUEST)]
      if (this.usersListStatus !== 'saved') {
        apiList.push(this.$store.dispatch(USER_LIST_REQUEST))
      }
      Promise.all(apiList).then(
        results => {
          this.loading = false
          this.$store.dispatch(USER_LIST_SUCCESS)
        },
        errMsg => {
          this.$store.dispatch(USER_LIST_SUCCESS)
        }
      )
    },
    gotoIntegrationWorkflow () {
      this.$router.push({
        name: 'integration-configuration'
      })
    },
    gotoConfigure (integrationType) {
      if (!this.$allow('network', 'write')) {
        this.$message({
          type: 'warning',
          message: "Sorry, you don't have permission"
        })
      } else {
        let query = {}
        let routename = 'integration-workflow'
        if (integrationType === 'installation') {
          routename = 'installation'
        } else if (integrationType === 'kubernetes') {
          routename = 'installation'
          this.$router.push({
            name: routename,
            params: { os: 'kubernetes' },
            query: { os: 'kubernetes' }
          })
          return true
        }
        this.$router.push({
          name: routename,
          params: { integrationType: integrationType },
          query: query
        })
      }
    },
    gotoUsers () {
      this.$router.push({
        name: 'preferences',
        query: { view: 'users' }
      })
    },
    gotoNotifications () {
      this.$router.push({
        name: 'preferences',
        query: { view: 'slack' }
      })
    }
  },
  created () {
    this.callApi()
  },
  computed: {
    ...mapGetters([
      'cloudIntegrationAccountsReqStatus',
      'cloudIntegrationAccounts',
      'cloudIntegrationSummary',
      'integrationListReqStatus',
      'integrationList',
      'usersListStatus',
      'usersList'
    ]),
    cloudIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'DISCOVERY'
      })
    },
    azureIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'AZUREDISCOVERY'
      })
    },
    gcpIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'GCPDISCOVERY'
      })
    },
    kubernetesIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'KUBERNETES'
      })
    },
    albIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'ALB'
      })
    },
    panIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'PAN'
      })
    },
    snykIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'SNYK'
      })
    },
    carbonblackIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'CARBONBLACK'
      })
    },
    guarddutyblackIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'GUARDDUTY'
      })
    },
    trendmicroIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'TRENDMICRO'
      })
    },
    rdsIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'RDS'
      })
    },
    cloudtrailIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'CLOUDTRAIL'
      })
    },
    historicalCloudTrailDataIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'CLOUDTRAIL_HISTORY'
      })
    },
    jiraIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'jira'
      })
    },
    devoIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'DEVO'
      })
    },
    wefIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'WEF'
      })
    },
    azurelogIntegrations () {
      return _.filter(this.integrationList, integration => {
        return integration.type === 'AZURELOG'
      })
    }
  },
  watch: {},
  components: {
    PageHeaders,
    IntegrationCard
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';

.integration-menu,
.integration-settings {
  overflow: scroll;
  height: calc(100vh - 280px);
}

.integration-menu {
  .el-menu-item.is-active,
  .el-menu-item:hover {
    background-color: #fff;
  }
}

.view.box.grow.integration-content {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
}

.integration-settings {
  width: 50%;

  .el-steps {
    padding: 20px 10px 25px 10px;
    margin: 0 0 20px 0;
    border-bottom: solid 1px #f0f0f0;
  }

  .el-carousel {
    margin: 10px 0 30px 0;

    p {
      width: 480px;
      margin: 0 auto;
      padding: 2px;
      font-weight: bold;
      text-align: center;
      background: #f0f0f0;
    }

    .screenshot {
      margin: 10px auto 0 auto;
      width: 480px;
      background: #f8f8f8;

      .box {
        color: #999999;
      }
    }

    .el-carousel__item h3 {
      color: #333333;
      font-size: 18px;
      text-transform: uppercase;
    }
  }
}

>>> .el-button-group {
  width: inherit;

  .el-button {
    float: right !important;
  }
}

.icon-text-button {
  background: var(--main-blue);
  padding: 5px 10px;

  span {
    .c-icon {
      color: white;
      font-size: 1.2em;
      vertical-align: text-bottom;
      margin-right: 5px;
    }
    span {
      color: white;
      margin-bottom: 6px;
    }
  }

  &.is-disabled {
    background: #cccccc;
  }
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0.5em 0px;
}

.footer {
  margin-top: 10px;
}

.integration-row {
  min-height: 175px;
}

>>> .el-row--flex {
  flex-wrap: wrap;
}

>>> .integration-card {
  .card_header {
    text-align: center;
    margin: auto;
  }

  .icon {
    display: block;
    mask-repeat: no-repeat;
    mask-size: 8em;
    width: 120px;
    height: 45px;
    /* background: var(--main-gray); */
  }

  .non-logo {
    height: 45px;
    font-size: 2.3em !important;
    margin-top: 30%;
    opacity: 0.38;
  }

  .hidden {
    visibility: hidden;
  }
}

.el-link.el-link--default {
  color: var(--aluminum-400);

  .material-icons {
    font-size: 20px;
  }
}

p {
  margin: 0px;
}

.text-btn {
  cursor: pointer;
  color: #409eff;
}

.launchpad-title {
  height: 36px;
  width: 456px;
  color: #454b60;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.12px;
  line-height: 36px;
}

.launchpad-subtitle {
  height: 44px;
  width: 789px;
  color: #454b60;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
}

.cloud-assets {
  height: 18px;
  width: 426px;
  color: #454b60;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
}

.team-card-title {
  height: 18px;
  width: 111px;
  color: #454b60;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
  margin-left: 20px;
}

.slack-card-title,
.jira-card-title {
  white-space: nowrap;
  height: 18px;
  width: 111px;
  color: #454b60;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 18px;
  margin-left: 20px;
}

.jira-logo-header {
  height: 40px;
  width: 166px;
  color: #454b60;
  font-size: 13px;
  letter-spacing: 0;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/integrations/Integrations.vue